var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEconomy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.075 3.98326L16 3.93996L15.925 3.98326L5.63081 9.92668L5.55581 9.96998V10.0566V21.9434V22.03L5.63081 22.0733L15.925 28.0167L16 28.06L16.075 28.0167L26.3694 22.0733L26.4444 22.03V21.9434V10.0566V9.96998L26.3694 9.92668L16.075 3.98326ZM16.0001 15.435L8.75681 11.2533L16.0001 7.07148L23.2433 11.2533L16.0001 15.435ZM16.489 24.644L16.4892 16.2816L23.7318 12.1001V20.4636L16.489 24.644ZM15.5114 24.6442L8.268 20.464V12.1L15.5113 16.2815L15.5114 24.6442ZM16 2.15C23.6491 2.15 29.85 8.35088 29.85 16C29.85 23.6491 23.6491 29.85 16 29.85C8.35088 29.85 2.15 23.6491 2.15 16C2.15 8.35088 8.35088 2.15 16 2.15Z",
    fill: "url(#paint0_radial_1622_2161)",
    stroke: "#007F6A",
    strokeWidth: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1622_2161",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30 1.57586) rotate(135.659) scale(39.1506)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.151033,
    stopColor: "#00FFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865538,
    stopColor: "#197D6B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomy);
export default __webpack_public_path__ + "static/media/economy.99e6303f4a9e001fa6e4608d7c1ae76a.svg";
export { ForwardRef as ReactComponent };